<template>
  <div>
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
          <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getRecordBranchWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Type">Loan Type</label>
                  <select
                    v-model="form.loanType"
                    name="loanType"
                    @change="getRecordBranchWise"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('loanType'),
                    }"
                    required
                  >
                    <option value="">All</option>
                    <option value="group">Group</option>
                    <option value="individual">Individual</option>
                  </select>
                  <has-error
                    :form="form"
                    field="loanType"
                  ></has-error>
                </div>
                <div class="col-md-3">

                  <div class="form-group">
                    <label
                      >Recovery type
                      <span class="red">*</span></label
                    >
                    <select
                      v-model="form.recoveryType"
                      name="recoveryType"
                      class="form-control"
                      @change="changeFilter"
                      :class="{
                        'is-invalid': form.errors.has(
                          'recoveryType'
                        ),
                      }"
                    >
                      <option value="">All</option>
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="BiWeekly">BiWeekly</option>
                      <option value="HalfMonth">Half Month</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                      <option value="OneTime">One Time</option>

                    </select>
                    <has-error
                      :form="form"
                      field="recoveryType"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Select Plan Type
                      <span class="red">*</span></label
                    >
                    <select
                      v-model="form.planType"
                      name="planType"
                      class="form-control"
                      @change="changeFilter"
                    >
                      <option value="">All</option>
                      <option value="normal">Normal Plan</option>
                      <option value="normalReduced">Normal Reduced Plan</option>
                      <option value="special">Special Plan</option>
                      <option value="custom">Custom Plan</option>
                      <option value="manual">Manual Plan</option>
                    </select>
                    <has-error :form="form" field="planType"></has-error>
                  </div>
                </div>
                <div class="col-md-3" v-if="form.loanType === 'group' && form.branch_id !== ''">
                  <label for="Branch">Group</label>
                  <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="getRecordCenterWise" required></v-select>
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Select Payment Status <span class="red">*</span></label
                    >
                    <select
                      v-model="form.status"
                      name="status"
                      @change="changeFilter"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('status'),
                      }"
                    >
                      <option value="">All</option>
                      <option value="approved">Approved</option>
                      <option value="pending">Pending</option>
                    </select>
                    <has-error :form="form" field="status"></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Select Ledger Account </label>
                    <select
                      v-model="form.branch_ledger_id"
                      name="branch_ledger_id"
                      class="form-control"
                      @change="changeFilter()"
                      :class="{
                        'is-invalid': form.errors.has('branch_ledger_id'),
                      }"
                    >
                      <option v-if="!form.branch_ledger_id" selected value="">
                        Select Ledger Account
                      </option>

                      <option
                        :value="payment_ledger.id"
                        v-for="payment_ledger in payment_ledgers"
                        :key="payment_ledger.id"
                      >
                        {{payment_ledger.name}} {{payment_ledger.remark}}
                      </option>
                    </select>
                    <has-error :form="form" field="branch_ledger_id"></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Staff (Type Here)</label>
                  <v-select v-model="staff" name="staff_id" :filterable="false" label="name" :options="staffs" placeholder="Select Staff" @search="getStaffRecord" v-on:input="getRecordAgentWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="staff_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Member (Type Here)</label>
                  <v-select v-model="member" name="member_id" :filterable="false" label="name" :options="members" placeholder="Select Member" @search="getMemberRecord" v-on:input="getRecordMemberWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="staff_id"
                  ></has-error>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label for="date">Disbursement Date</label>
                  <input type="date" v-model="form.disbursementDate" name="disbursementDate" class="form-control" @change="selectdisbursementDate" placeholder="EMI Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Disbursement Date From</label>
                  <input type="date" v-model="form.disbursementStartDate" name="disbursementStartDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Disbursement Date To</label>
                  <input type="date" v-model="form.disbursementEndDate" name="disbursementEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment End Date">
                </div>
                <div class="col-md-3">
                  <label for="date">EMI End Date From</label>
                  <input type="date" v-model="form.startEmiEndDate" name="startEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">EMI End Date To</label>
                  <input type="date" v-model="form.endtEmiEndDate" name="endEmiEndDate" class="form-control" @change="changeFilter" placeholder="Disbursment Start Date">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>

          <!-- /.card -->
      <!-- /.row -->
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('member-loan-plan-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Disbursement Records</h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/loandisbursement/export/excel`" class="btn btn-box-tool" v-if="canAccess('staff-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <strong><big>Total Loan Amount: {{this.totalAmount}} </big></strong>
            <strong><big> | Total Disb Amount: {{this.totalDisbAmount}} </big></strong>
          </div>

        </div>
        <div class="box-body">
          <!-- <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
              </label>
            </div>
            <div class="col-sm-6">
              <div class="input-group pull-right input-group-sm">
                Total Amount: {{this.totalAmount}}
              </div>
            </div>
          </div> -->
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>LoanID </th>
                <th>Mem Name </th>
                <th>Mem Code </th>
                <th>Mobile</th>
                <th>CenterName</th>
                <th class="hidden-xs">Disbursement Date</th>
                <th class="hidden-xs">Loan Start Date</th>
                <th class="hidden-xs">Loan End Date</th>
                <th>Loan Amount</th>
                <th>Disb Amount</th>
                <!-- <th>To Pay</th> -->
                <!-- <th>Disb By</th> -->
                <th>Staff</th>
                <th>Pay Mode</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rowsMemberCollections" :key="index">
                <td class="hidden-xs">{{ (index +1) }}</td>
                <td><span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                <td>{{ row.member.name }}</td>
                <td>{{ row.member.code }}</td>
                <td>{{ row.member.mobile }}</td>
                <td><span v-if="row.collection_center_id">{{ row.collection_center.name }}</span></td>
                <td class="hidden-xs">{{ row.disbursementDate | myDate}}</td>
                <td class="hidden-xs">{{ row.emiStartDate | myDate}}</td>
                <td class="hidden-xs">{{ row.emiEndDate | myDate}}</td>
                <!-- <td>{{ planAmt(row) }}</td> -->
                <td>{{ planAmt(row) }}</td>
                <td>{{ disAmt(row) }}</td>
                <!-- <td>{{ row.loanAmount }}</td> -->
                <!-- <td><span v-if="row.disbursedBy">{{ row.disbursed_by.name }}</span></td> -->
                <td><span v-if="row.agent">{{ row.agent.name }}</span></td>
                <td><span v-if="row.branch_ledger">{{ row.branch_ledger.ledger.name }}</span></td>
                <td><span
                      v-if="row.status == 'pending'"
                      class="label label-warning"
                      >Pending</span
                    >
                    <span
                      v-if="row.status == 'disbursed'"
                      class="label label-success"
                      >Disbursed</span
                    >
                    <span
                      v-if="row.status == 'approved'"
                      class="label label-success"
                      >Approved</span
                    >
                    <span
                      v-if="row.status == 'partial'"
                      class="label label-info"
                      >Partial</span
                    >
                </td>
                <!-- <td>
                  <div class="btn-group">
                    <button
                      v-if="row.status === 'approved'"
                      @click="voucherView(row.id)"
                      class="btn btn-warning btn-xs"
                    >
                      <i class="fa fa-book" aria-hidden="true"></i>
                    </button>
                    <button
                      @click="printView(row)"
                      class="btn btn-warning btn-xs"
                    >
                      <i class="fa fa-print" aria-hidden="true"></i>
                    </button>
                    <button
                      v-if="canAccess('member-collection-delete')"
                      @click="confirmPayment(row)"
                      class="btn btn-danger btn-xs"
                    >
                    <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
import GetBranch from '../../mixins/BranchRecords'
import GetPaymentBranchLedgers from '../../mixins/PaymentBranchLedgers'
export default {
  name: 'my-component',
  mixins: [GetBranch, GetPaymentBranchLedgers],
  data () {
    return {
      table_search: '',
      isLoading: false,
      editMode: false,
      emiDate: null,
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      payment_ledgers: [],
      pancardNumber: '',
      branches: [],
      branch: {},
      members: [],
      member: {},
      staffs: [],
      staff: {},
      banks: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      loadDisbursements: {},
      totalAmount: 0,
      totalDisbAmount: 0,
      viewCollectionCenter: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: 'disbursementDate',
          type: 'date'
        },
        page: 1,
        perPage: 10
      },
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        type: '',
        loanType: '',
        planType: '',
        disbursed_by: '',
        recoveryType: '',
        member_id: '',
        branch_ledger_id: '',
        status: '',
        disbursement_id: '',
        disbursementDate: new Date().toISOString().slice(0, 10),
        disbursementStartDate: '',
        disbursementEndDate: '',
        startEmiEndDate: '',
        endEmiEndDate: '',
        paymentMode: '',
        bank_id: ''
      }),
      rowsMemberCollections: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getRecordAgentWise () {
      this.form.agent_id = ''
      if (this.staff) {
        this.form.agent_id = this.staff.user_id
      }
      this.changeFilter()
    },
    getRecordMemberWise () {
      this.form.member_id = ''
      if (this.member) {
        this.form.member_id = this.member.user_id
      }
      this.changeFilter()
    },
    getRecordBranchWise () {
      this.totalAmount = 0
      this.totalDisbAmount = 0
      this.form.branch_id = ''
      this.form.agent_id = ''
      this.form.member_id = ''
      this.staffs = []
      this.staff = {}
      this.collectionCenters = []
      this.collectionCenter = {}
      if (this.branch) {
        this.form.branch_id = this.branch.id
        this.getPaymentBranchLedgers()
      }
      if (this.form.branch_id !== '' && this.form.loanType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      this.changeFilter()
    },
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? parseInt(row.insuranceFee) : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    disAmt (row) {
      var pln = JSON.parse(row.plan)
      return row.loanAmount ? row.loanAmount : pln.amount
    },
    getRecordCenterWise () {
      this.form.collection_center_id = ''
      if (this.collectionCenter) {
        this.form.collection_center_id = this.collectionCenter.id
      }
      this.changeFilter()
    },
    selectdisbursementDate () {
      if (this.form.disbursementDate) {
        this.form.emiStartDate = ''
        this.form.emiEndDate = ''
      }
      this.changeFilter()
    },
    selectBetweendisbursementDate () {
      if (this.form.emiStartDate && this.form.emiEndDate) {
        this.form.disbursementDate = ''
        this.changeFilter()
      } else if (this.form.emiStartDate === '' && this.form.emiEndDate === '') {
        this.changeFilter()
      } else {
        this.form.disbursementDate = ''
      }
    },
    changeFilter () {
      var c = JSON.parse(localStorage.user)
      this.totalAmount = 0
      this.totalDisbAmount = 0
      if (c.type === 'staff') {
        this.branch.id = c.agent_profile.branch_id
      }
      // alert('hello')
      var pageUrl = ''
      pageUrl += 'disbursement?status=disbursed&all=all'
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (this.form.agent_id) {
        pageUrl += `&agent_id=${this.form.agent_id}`
      }
      if (this.form.member_id) {
        pageUrl += `&member_id=${this.form.member_id}`
      }
      if (this.form.branch_ledger_id) {
        pageUrl += `&branch_ledger_id=${this.form.branch_ledger_id}`
      }
      if (this.form.loanType) {
        pageUrl += `&searchTerm=${this.form.loanType}`
      }
      if (this.form.recoveryType) {
        pageUrl += `&recoveryType=${this.form.recoveryType}`
      }
      if (this.form.planType) {
        pageUrl += `&planType=${this.form.planType}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      if (this.form.disbursementDate) {
        pageUrl += `&disbursementDate=${this.form.disbursementDate}`
      }
      if (this.form.disbursementStartDate) {
        pageUrl += `&disbursementStartDate=${this.form.disbursementStartDate}`
      }
      if (this.form.disbursementEndDate) {
        pageUrl += `&disbursementEndDate=${this.form.disbursementEndDate}`
      }
      if (this.form.startEmiEndDate) {
        pageUrl += `&startEmiEndDate=${this.form.startEmiEndDate}`
      }
      if (this.form.endEmiEndDate) {
        pageUrl += `&endEmiEndDate=${this.form.endEmiEndDate}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // this.totalAmount = _.sumBy(data.data, 'amt')
          this.rowsMemberCollections = data.data

          for (var i = 0; i < this.rowsMemberCollections.length; i++) {
            var fpi = 0
            var gstAmt = 0
            var pln = JSON.parse(this.rowsMemberCollections[i].plan)
            if (pln.planType !== 'normal') {
              if (pln.fileChargeIncludeAmt === 'true') {
                fpi += this.rowsMemberCollections[i].fileCharge ? this.rowsMemberCollections[i].fileCharge : parseInt(pln.fileCharge)
              }
              if (pln.processingFeeIncludeAmt === 'true') {
                fpi += this.rowsMemberCollections[i].processingFee ? this.rowsMemberCollections[i].processingFee : parseInt(pln.processingFee)
              }
              if (pln.insuranceFeeIncludeAmt === 'true') {
                fpi += this.rowsMemberCollections[i].insuranceFee ? parseInt(this.rowsMemberCollections[i].insuranceFee) : parseInt(pln.insuranceFee)
              }
              if (pln.includeGst === 'true') {
                gstAmt = fpi * 18 / 100
                fpi += parseInt(gstAmt)
              }
              // console.log(this.totalAmount)
              this.totalAmount += this.rowsMemberCollections[i].loanAmount ? parseInt(this.rowsMemberCollections[i].loanAmount + fpi) : parseInt(pln.amount + fpi)
              this.totalDisbAmount += this.rowsMemberCollections[i].loanAmount ? parseInt(this.rowsMemberCollections[i].loanAmount) : parseInt(pln.amount)
              // console.log('========' + i)
              // console.log(this.totalAmount)
              this.rowsMemberCollections[i].totAmt = this.rowsMemberCollections[i].loanAmount ? this.rowsMemberCollections[i].loanAmount + fpi : pln.amount + fpi
            } else {
              // console.log(this.totalAmount)
              this.totalAmount += this.rowsMemberCollections[i].loanAmount ? parseInt(this.rowsMemberCollections[i].loanAmount) : parseInt(pln.amount)
              this.totalDisbAmount += this.rowsMemberCollections[i].loanAmount ? parseInt(this.rowsMemberCollections[i].loanAmount) : parseInt(pln.amount)
              // console.log('========++++++++++++' + i)
              // console.log(this.totalAmount)
              this.rowsMemberCollections[i].totAmt = this.rowsMemberCollections[i].loanAmount ? this.rowsMemberCollections[i].loanAmount : pln.amount
            }
          }
        })
        .catch(function (error) { console.log(error) })
    },
    getStaffRecord (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.$axios.get('staff?all=all&branch_id=' + this.form.branch_id + '&name=' + search, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
          loading(false)
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    },
    getMemberRecord (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.$axios.get('member?all=all&branch_id=' + this.form.branch_id + '&name=' + search, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
          loading(false)
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    }
  },
  created () {
    this.getBranch()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>




// WEBPACK FOOTER //
// DisbursementReport.vue?6db98399